module.exports = __webpack_public_path__ + "img/gl.875d9529.svg";